import React, { forwardRef, useCallback } from 'react';
import { ReactSlideEvent, ReactMouseEvent } from '../types';

export interface HandlerProps {
	className: string;
	vertical: boolean;
	percentage: number;
	onSlideStart: (event: ReactSlideEvent) => void;
}

const Handler = forwardRef<HTMLDivElement, HandlerProps>((
	{ className, vertical, percentage, onSlideStart },
	ref
) => {
	const onClick = useCallback((event: ReactMouseEvent) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();
	}, []);

	let style;

	if (vertical) {
		style = { top: `${100 - percentage}%` };
	} else {
		style = { left: `${percentage}%` };
	}

	return (
		<div
			ref={ref}
			className={className}
			tabIndex={0}
			onTouchStart={onSlideStart}
			onMouseDown={onSlideStart}
			onClick={onClick}
			style={style}
		/>
	);
});

export default Handler;
